// Wait for store data to be available
async function waitForStoreData() {
  let attempts = 0;
  while ((!window.storeLocations || window.storeLocations.length === 0) && attempts < 20) {
    await new Promise(resolve => setTimeout(resolve, 100));
    attempts++;
  }
  return window.storeLocations || [];
}

// Use the global storeLocations from window (initialized in theme.liquid)
// DO NOT redeclare - this causes "Identifier 'storeLocations' has already been declared" error
let storeLocations = window.storeLocations || [];

// Store Locator JavaScript with Standard Markers
// Function to generate state filter tabs dynamically
function generateStateFilterTabs() {
  // Get unique states from storeLocations
  const uniqueStates = [...new Set(storeLocations.map(store => store.state))].sort();
  
  // Count stores per state for debugging
  const storeCountByState = {};
  storeLocations.forEach(store => {
    storeCountByState[store.state] = (storeCountByState[store.state] || 0) + 1;
  });
  console.log('Store count by state:', storeCountByState);
  
  // Get the container
  const tabsContainer = document.getElementById('state-filter-tabs');
  
  // Clear existing tabs except "All Locations"
  tabsContainer.innerHTML = '<div class="state-tab active" data-state="All Locations">All Locations</div>';
  
  // Add a tab for each unique state
  uniqueStates.forEach(state => {
    const stateTab = document.createElement('div');
    stateTab.className = 'state-tab';
    stateTab.dataset.state = state;
    stateTab.textContent = state;
    
    // Add click event listener
    stateTab.addEventListener('click', () => {
      // Remove active class from all tabs
      const stateTabs = document.querySelectorAll('#state-filter-tabs .state-tab');
      stateTabs.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked tab
      stateTab.classList.add('active');
      
      // Filter stores by selected state
      loadStores({ state: state });
    });
    
    tabsContainer.appendChild(stateTab);
  });
  
  // Update the total store count display
  const totalStore = document.querySelector('.total-store');
  if (totalStore) {
    totalStore.textContent = `${storeLocations.length} Locations`;
  }
}

// Configuration
const config = {
  mapElementId: 'store-locator-map',
  listElementId: 'store-list-container',
  searchElementId: 'store-search-input',
  stateFilterElementId: 'state-filter-tabs',
  defaultZoom: 7,
  defaultCenter: { lat: 34.0, lng: -83.0 }, // Somewhere in Georgia/South Carolina
  searchRadius: 25, // miles
};

// Global variables
let map;
let markers = [];
let infoWindow;
let userLocation = null;
let geocoder; // Add geocoder as a global variable

// Store data structure example (keep your existing storeLocations array)

// Make initStoreLocator globally accessible
window.initStoreLocator = async function() {
  // Wait for store data first
  console.log('Waiting for store data...');
  storeLocations = await waitForStoreData();
  console.log(`Store data loaded: ${storeLocations.length} stores`);
  
  // Wait for DOM to be fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStoreLocator);
  } else {
    initializeStoreLocator();
  }
};

// Initialize store locator with stored location detection
function initializeStoreLocator() {
  // Check for stored ZIP code first
  checkStoredLocation();
  
  // Then load Google Maps
  loadGoogleMapsScript();
}

// Check for stored location from the location filtering system
function checkStoredLocation() {
  console.log('[StoreLocator] Checking for stored location...');

  // Use LocationUtils to get stored location
  const location = LocationUtils.getLocation();
  if (location?.zipCode) {
    console.log(`[StoreLocator] Found stored ZIP code:`, location.zipCode);
    // Wait a moment for DOM to be ready, then populate and search
    setTimeout(() => populateAndSearch(location.zipCode), 500);
    return;
  }

  console.log('[StoreLocator] No stored location found');
}

// Auto-populate search field and perform search
function populateAndSearch(zipCode) {
  const searchInput = document.getElementById('store-search-input');
  if (searchInput) {
    console.log('[StoreLocator] Auto-populating search with:', zipCode);
    searchInput.value = zipCode;

    // Trigger the search
    handleZipCodeSearch(zipCode);
  } else {
    console.warn('[StoreLocator] Search input not found, retrying in 1 second...');
    setTimeout(() => populateAndSearch(zipCode), 1000);
  }
}

// Initialize the map (will be called by Google Maps API when loaded)
// THIS FUNCTION MUST BE DEFINED GLOBALLY
window.initMap = function() {
  try {
    console.log('Initializing map...');
    // Create the map
    map = new google.maps.Map(document.getElementById(config.mapElementId), {
      zoom: config.defaultZoom,
      center: config.defaultCenter,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
    });
    
    infoWindow = new google.maps.InfoWindow();
    
    // Initialize the geocoder
    geocoder = new google.maps.Geocoder();

    // Generate state filter tabs dynamically
    generateStateFilterTabs();
    
    // Try to get user's location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          map.setCenter(userLocation);
          loadStores();
        },
        () => {
          // User denied geolocation or error
          loadStores();
        }
      );
    } else {
      // Browser doesn't support geolocation
      loadStores();
    }
    
    // Set up event listeners
    setupEventListeners();
    
  } catch (error) {
    console.error("Error initializing Google Maps:", error);
    document.getElementById(config.mapElementId).innerHTML = 
      '<div class="map-error">There was an error loading the map. Please refresh the page and try again.</div>';
  }
};

// Function to load Google Maps script
function loadGoogleMapsScript() {
  // Check if map container exists
  if (!document.getElementById(config.mapElementId)) {
    console.log('Map container not found');
    return;
  }
  
  // Check if Google Maps is already loaded
  if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
    console.log('Loading Google Maps API...');
    
    // Get API key from data attribute
    const apiKey = document.getElementById(config.mapElementId).dataset.apiKey;
    if (!apiKey) {
      console.error('No API key found. Add data-api-key attribute to the map container.');
      document.getElementById(config.mapElementId).innerHTML = 
        '<div class="map-error">Google Maps API key is missing. Please check your configuration.</div>';
      return;
    }
    
    // Create script element - Updated to include the geocoding library
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initMap`;
    script.async = true;
    script.defer = true;
    
    // Add error handling
    script.onerror = function() {
      console.error('Failed to load Google Maps API');
      document.getElementById(config.mapElementId).innerHTML = 
        '<div class="map-error">Failed to load Google Maps. Please check your internet connection and try again.</div>';
    };
    
    // Append script to head
    document.head.appendChild(script);
  } else {
    console.log('Google Maps already loaded, initializing map directly');
    // Google Maps already loaded, call initMap directly
    window.initMap();
  }
}

// NEW FUNCTION: Geocode an address or zip code to get coordinates
function geocodeAddress(address, callback) {
  if (!geocoder) {
    geocoder = new google.maps.Geocoder();
  }
  
  geocoder.geocode({ 'address': address }, function(results, status) {
    if (status === google.maps.GeocoderStatus.OK && results[0]) {
      const location = {
        lat: results[0].geometry.location.lat(),
        lng: results[0].geometry.location.lng()
      };
      callback(location);
    } else {
      console.error('Geocoding failed: ' + status);
      alert('We could not find that location. Please try a different search term.');
    }
  });
}

// Load and display stores
function loadStores(filter = {}) {
  // Clear existing markers
  clearMarkers();
  
  // Filter stores based on criteria (state, search term, etc.)
  let filteredStores = storeLocations;
  
  // Filter by state if specified
  if (filter.state && filter.state !== 'All Locations') {
    filteredStores = filteredStores.filter(store => store.state === filter.state);
    console.log(`Filtering for state ${filter.state}: found ${filteredStores.length} stores`);
    // Log the actual stores for debugging
    filteredStores.forEach(store => {
      console.log(`- ${store.name} (${store.id}) - deliveryOnly: ${store.deliveryOnly}`);
    });
  }
  
  // Filter by search term if specified (but NOT for zip code searches)
  if (filter.searchTerm && !filter.isZipSearch) {
    const term = filter.searchTerm.toLowerCase();
    filteredStores = filteredStores.filter(store => 
      store.name.toLowerCase().includes(term) ||
      store.city.toLowerCase().includes(term) ||
      store.state.toLowerCase().includes(term) ||
      (store.zip && store.zip.includes(term))
    );
  }
  
  // Filter by delivery only if the checkbox is checked
  if (filter.deliveryOnly) {
    filteredStores = filteredStores.filter(store => store.deliveryOnly);
  }
  
  // If user location is available, calculate distances
  let storesWithDistance = filteredStores;
  if (userLocation) {
    storesWithDistance = filteredStores.map(store => {
      // Only calculate distance if coordinates are available
      if (store.coordinates) {
        const distance = calculateDistance(
          userLocation.lat, userLocation.lng,
          store.coordinates.lat, store.coordinates.lng
        );
        return { ...store, distance };
      }
      return store;
    });
    
    // Filter by radius if specified
    if (filter.radius) {
      storesWithDistance = storesWithDistance.filter(store => 
        store.distance && store.distance <= filter.radius
      );
    }
    
    // Sort by distance
    storesWithDistance.sort((a, b) => {
      // Handle cases where distance might not be available
      if (!a.distance) return 1;
      if (!b.distance) return -1;
      return a.distance - b.distance;
    });
  }
  
  // Update store count display
  updateStoreCountDisplay(storesWithDistance.length, filter.radius || config.searchRadius);
  
  // Add markers to the map
  storesWithDistance.forEach(store => {
    // Only add marker if coordinates are available
    if (store.coordinates) {
      addMarker(store);
    }
  });
  
  // Adjust map bounds to show all markers
  if (markers.length > 0) {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(marker => bounds.extend(marker.getPosition()));
    map.fitBounds(bounds);
    
    // Add zoom control to avoid excessive zoom on single marker
    if (markers.length === 1) {
      google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
        if (map.getZoom() > 15) {
          map.setZoom(15);
        }
      });
    }
  } else {
    // No stores found
    document.getElementById(config.listElementId).innerHTML = 
      '<div class="no-stores-found">No stores found matching your criteria.</div>';
  }
  
  // Update the list view
  updateListView(storesWithDistance);
}

// Add a standard marker for a store
function addMarker(store) {
  // Create marker icon with custom color
  const markerIcon = {
    path: "M12 0C7.802 0 4 3.403 4 7.602C4 11.8 12 24 12 24S20 11.8 20 7.602C20 3.403 16.199 0 12 0ZM12 11C10.343 11 9 9.657 9 8C9 6.343 10.343 5 12 5C13.657 5 15 6.343 15 8C15 9.657 13.657 11 12 11Z",
    fillColor: store.deliveryOnly ? "#FFA07A" : "#00A14B", // Light salmon for delivery-only, green for regular stores
    fillOpacity: 1,
    strokeWeight: 0,
    rotation: 0,
    scale: 1.5,
    anchor: new google.maps.Point(12, 24),
  };
  
  // Create the standard marker
  const marker = new google.maps.Marker({
    position: store.coordinates,
    map: map,
    title: store.name,
    icon: markerIcon,
    animation: google.maps.Animation.DROP
  });
  
  // Store the store ID with the marker for reference
  marker.storeId = store.id;
  
  marker.addListener('click', () => {
    showStoreInfo(store, marker);
  });
  
  markers.push(marker);
  return marker;
}

// Clear all markers from the map
function clearMarkers() {
  markers.forEach(marker => marker.setMap(null));
  markers = [];
}

// Show info window for a store
function showStoreInfo(store, marker) {
  // Close any open info windows
  infoWindow.close();
  
  // Format distance with appropriate precision
  let distanceDisplay = '';
  if (store.distance !== undefined) {
    distanceDisplay = formatDistance(store.distance);
  }
  
  // Build the content for the info window
  const content = `
    <div class="store-info-window">
      <h3>${store.name}</h3>
      <p>${store.address}<br>${store.city}, ${store.state} ${store.zip}</p>
      <p>Phone: ${store.phone}</p>
      ${distanceDisplay ? `<p>Distance: ${distanceDisplay}</p>` : ''}
      <div class="store-info-actions">
        <a href="tel:${store.phone}" class="action-call">Call</a>
        <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
          `${store.address}, ${store.city}, ${store.state}`
        )}" target="_blank" class="action-directions">Get Directions</a>
      </div>
    </div>
  `;
  
  infoWindow.setContent(content);
  infoWindow.open(map, marker);
}

// NEW FUNCTION: Format distance with better precision
function formatDistance(distance) {
  if (distance < 0.1) {
    return distance.toFixed(2) + ' miles';
  } else if (distance < 1) {
    return distance.toFixed(1) + ' miles';
  } else {
    return Math.round(distance * 10) / 10 + ' miles';
  }
}

// Update the list view with filtered stores
function updateListView(stores) {
  const listContainer = document.getElementById(config.listElementId);
  if (!listContainer) {
    console.error('Store list container not found');
    return;
  }
  
  listContainer.innerHTML = '';
  
  if (stores.length === 0) {
    listContainer.innerHTML = '<div class="no-stores-found">No stores found matching your criteria.</div>';
    return;
  }
  
  // Add your closest store section if there's at least one store and user location is available
  if (stores.length > 0 && userLocation) {
    const closestStore = stores[0]; // First store is closest due to sorting
    
    const closestStoreElement = document.createElement('div');
    closestStoreElement.className = 'closest-store-item store-item';
    closestStoreElement.dataset.storeId = closestStore.id;
    
    // Format distance with better precision
    let distanceDisplay = '';
    if (closestStore.distance !== undefined) {
      distanceDisplay = formatDistance(closestStore.distance);
    }
    
    closestStoreElement.innerHTML = `
      <div class="store-item-header">
        <h3>${closestStore.name}</h3>
        ${closestStore.deliveryOnly ? '<span class="delivery-only-badge">DELIVERY ONLY</span>' : ''}
      </div>
      <div class="store-item-address">
        <p>${closestStore.address || ''}</p>
        <p>${closestStore.city}, ${closestStore.state} ${closestStore.zip || ''}</p>
      </div>
      <div class="store-item-phone">
        <a href="tel:${closestStore.phone}">${closestStore.phone}</a>
      </div>
      <div class="store-item-distance">
        ${distanceDisplay ? `${distanceDisplay} away` : ''}
      </div>
      <div class="store-item-actions">
        ${closestStore.address ? `
          <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
            `${closestStore.address}, ${closestStore.city}, ${closestStore.state}`
          )}" target="_blank" class="button get-directions-btn">GET DIRECTIONS</a>
        ` : ''}
      </div> 
    `;
    
    // Add click handler to highlight on map
    closestStoreElement.addEventListener('click', (e) => {
      if (!e.target.closest('a')) {
        // Find the marker for this store
        const marker = markers.find(m => m.storeId === closestStore.id);
        if (marker) {
          // Center map on this marker
          map.setCenter(marker.getPosition());
          map.setZoom(14);
          // Show info window
          showStoreInfo(closestStore, marker);
        }
      }
    });
    
    // Add closest store to the list
    listContainer.appendChild(closestStoreElement);
    
    // Add separator
    const separator = document.createElement('div');
    separator.className = 'store-list-separator';
    listContainer.appendChild(separator);
    
    // Add subheading for other stores if there are more than one
    if (stores.length > 1) {
      const subheading = document.createElement('h3');
      subheading.className = 'other-stores-heading';
      subheading.textContent = 'OTHER STORES';
      listContainer.appendChild(subheading);
    }
  }
  
  // Skip the first store if we already displayed it as closest
  const startIndex = (stores.length > 0 && userLocation) ? 1 : 0;
  
  // Add the rest of the stores
  for (let i = startIndex; i < stores.length; i++) {
    const store = stores[i];
    
    const storeElement = document.createElement('div');
    storeElement.className = 'store-item';
    storeElement.dataset.storeId = store.id;
    
    // Format distance with better precision
    let distanceDisplay = '';
    if (store.distance !== undefined) {
      distanceDisplay = formatDistance(store.distance);
    }
    
    storeElement.innerHTML = `
      <div class="store-item-header">
        <h3>${store.name}</h3>
        ${store.deliveryOnly ? '<span class="delivery-only-badge">DELIVERY ONLY</span>' : ''}
      </div>
      <div class="store-item-address">
        <p>${store.address || ''}</p>
        <p>${store.city}, ${store.state} ${store.zip || ''}</p>
      </div>
      <div class="store-item-phone">
        <a href="tel:${store.phone}">${store.phone}</a>
      </div>
      ${distanceDisplay ? `
        <div class="store-item-distance">
          ${distanceDisplay} away
        </div>
      ` : ''}
      <div class="store-item-actions">
        ${store.address ? `
          <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
            `${store.address}, ${store.city}, ${store.state}`
          )}" target="_blank" class="button get-directions-btn">GET DIRECTIONS</a>
        ` : ''}
      </div>
    `;
    
    storeElement.addEventListener('click', (e) => {
      if (!e.target.closest('a')) {
        // Find the marker for this store
        const marker = markers.find(m => m.storeId === store.id);
        if (marker) {
          // Center map on this marker
          map.setCenter(marker.getPosition());
          map.setZoom(14);
          // Show info window
          showStoreInfo(store, marker);
        }
      }
    });
    
    listContainer.appendChild(storeElement);
  }
}

// Calculate distance between two points using LocationUtils
function calculateDistance(lat1, lon1, lat2, lon2) {
  return LocationUtils.calculateDistance(lat1, lon1, lat2, lon2);
}

// Update store count display
function updateStoreCountDisplay(count, radius) {
  const countElement = document.getElementById('store-count-display');
  if (countElement) {
    countElement.innerHTML = `Currently showing ${count} stores ${
      userLocation ? `` : ''
    }`;
  }
}

// NEW FUNCTION: Handle zip code search
function handleZipCodeSearch(zipCode) {
  // Check if it's a valid US zip code format
  const zipPattern = /^\d{5}(-\d{4})?$/;
  if (!zipPattern.test(zipCode)) {
    // Not a zip code, treat as normal search
    const activeStateTab = document.querySelector('#state-filter-tabs .state-tab.active');
    const state = activeStateTab ? activeStateTab.dataset.state : 'All Locations';
    loadStores({ state, searchTerm: zipCode });
    return;
  }
  
  // It's a zip code, use geocoding to get coordinates
  geocodeAddress(zipCode, function(location) {
    // Temporarily set user location to this zip code location
    userLocation = location;
    
    // Center map on this location
    map.setCenter(location);
    
    // Create a temporary marker for the zip code
    const zipMarker = new google.maps.Marker({
      position: location,
      map: map,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 7,
        fillColor: "#4285F4",
        fillOpacity: 1,
        strokeColor: "#FFFFFF",
        strokeWeight: 2
      },
      zIndex: 1
    });
    
    // Add info window for the zip code
    const zipInfoWindow = new google.maps.InfoWindow({
      content: `<div>Zip Code: ${zipCode}</div>`
    });
    
    zipMarker.addListener('click', () => {
      zipInfoWindow.open(map, zipMarker);
    });
    
    // Load stores based on this location
    loadStores({ isZipSearch: true });
    
    // Auto-remove the zip marker after 10 seconds
    setTimeout(() => {
      zipMarker.setMap(null);
    }, 10000);
  });
}

// Set up event listeners
function setupEventListeners() {
  // State filter tabs
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('state-tab')) {
      // Remove active class from all tabs
      const stateTabs = document.querySelectorAll('#state-filter-tabs .state-tab');
      stateTabs.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked tab
      e.target.classList.add('active');
      
      // Filter stores by selected state
      loadStores({ state: e.target.dataset.state });
    }
  });
  
  // Search input
  const searchInput = document.getElementById(config.searchElementId);
  if (searchInput) {
    searchInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        const searchTerm = searchInput.value.trim();
        if (searchTerm) {
          handleZipCodeSearch(searchTerm);
        }
      }
    });
    
    // Search button
    const searchButton = document.getElementById('store-search-button');
    if (searchButton) {
      searchButton.addEventListener('click', () => {
        const searchTerm = searchInput.value.trim();
        if (searchTerm) {
          handleZipCodeSearch(searchTerm);
        }
      });
    }
  }
  
  // Delivery Only filter
  const deliveryOnlyCheckbox = document.getElementById('delivery-only-checkbox');
  if (deliveryOnlyCheckbox) {
    deliveryOnlyCheckbox.addEventListener('change', () => {
      // Get currently selected state and search term
      const activeStateTab = document.querySelector('#state-filter-tabs .state-tab.active');
      const state = activeStateTab ? activeStateTab.dataset.state : 'All Locations';
      const searchTerm = document.getElementById(config.searchElementId).value.trim();
      // Filter stores
      loadStores({ 
        state, 
        searchTerm, 
        deliveryOnly: deliveryOnlyCheckbox.checked 
      });
    });
  }
  
  // Sort dropdown
  const sortDropdown = document.getElementById('sort-dropdown');
  if (sortDropdown) {
    sortDropdown.addEventListener('change', () => {
      // Get currently selected state and search term
      const activeStateTab = document.querySelector('#state-filter-tabs .state-tab.active');
      const state = activeStateTab ? activeStateTab.dataset.state : 'All Locations';
      const searchTerm = document.getElementById(config.searchElementId).value.trim();
      // Filter stores
      loadStores({ state, searchTerm, sortBy: sortDropdown.value });
    });
  }
  
  // Clear search button
  const clearSearch = document.getElementById('clear-search-button');
  if (clearSearch) {
    clearSearch.addEventListener('click', () => {
      const searchInput = document.getElementById(config.searchElementId);
      if (searchInput) {
        searchInput.value = '';
        
        // Reset to user's actual location if available
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              userLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              map.setCenter(userLocation);
              loadStores();
            },
            () => {
              // User denied geolocation or error
              userLocation = null;
              loadStores();
            }
          );
        } else {
          userLocation = null;
          loadStores();
        }
      }
    });
  }
}

// Export functions globally for use by other components
window.geocodeAddress = geocodeAddress;
window.calculateDistance = calculateDistance;